import { render, staticRenderFns } from "./ToContact.vue?vue&type=template&id=6ce55da4"
import script from "./ToContact.vue?vue&type=script&lang=js"
export * from "./ToContact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports